import React from 'react';
import PropTypes from 'prop-types';
import REDUCER_KEY from 'reducers/reducer.keys';
import { Inner } from 'components/Page';
import config from './config';

/*
 ** @description Prepare the data for the API
 ** @param object collection, name
 ** @returns object
 */
const handlePrepareData = ({ collection, name }) => ({
  collection_id: collection && collection.id ? collection.id : collection,
  name
});
const TagValues = ({ objectId, permissions }) => (
  <Inner
    canAdmin={permissions.CanAdminTags()
      .hasPermissions()}
    reducer={{
      parent: REDUCER_KEY.tags,
      item: REDUCER_KEY.tagValue,
      list: REDUCER_KEY.tagValues
    }}
    config={{
      ...config,
      list: {
        ...config.list,
        filters: {
          collection: [objectId]
        }
      },
      detail: {
        ...config.detail,
        parent: {
          collection: objectId
        }
      }
    }}
    onPrepareData={handlePrepareData}
    defaultSize="130px"
  />
);

TagValues.propTypes = {
  objectId: PropTypes.number,
  permissions: PropTypes.object.isRequired
};

TagValues.defaultProps = {
  objectId: null
};

export default TagValues;
